import { Box, Title, Icon, chooseColor } from 'vopay';
import { FunctionComponent, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAccountVerification } from '@/providers/AccountVerification.provider';
import { useLayout } from '@/providers/Layout.provider';
import useDataFetchIndicator from '@/hooks/useDataFetchIndicator';
import useConfirmContactVerification from '@/hooks/useApi/useConfirmContactVerification';
import styles from './VerifyContact.module.scss';

type VerifyContactType = {
  verificationType: 'email' | 'phone';
  token: string;
  otp: string;
};

type FC = FunctionComponent<VerifyContactType>;

const VerifyContact: FC = ({ verificationType, token, otp }) => {
  const { t } = useTranslation('translations', { keyPrefix: 'VerifySuccess' });
  const { setLayoutInfo } = useLayout();
  const { brandingInfo } = useAccountVerification();
  const { confirmVerification } = useConfirmContactVerification(verificationType);
  const [isCompleted, setIsCompleted] = useState(false);
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [isSuccess, setIsSuccess] = useState(false);
  useEffect(() => {
    setLayoutInfo(
      chooseColor<string | null | undefined>('#FFD147', brandingInfo?.BrandingDetails?.PrimaryColor),
      'curve',
      '',
      80,
      20,
      0,
      false,
      true,
    );
  }, [brandingInfo]);

  useEffect(() => {
    const verify = async () => {
      try {
        setDataFetchingInfo(true, 'Loading', 'fullScreen');
        const res = await confirmVerification({
          Token: token,
          OTP: otp,
        });
        setIsSuccess(res.Success);
        setIsCompleted(true);
      } catch (error) {
        console.error(error);
      } finally {
        setDataFetchingInfo(false);
      }
    };

    verify();
  }, []);

  const type = verificationType === 'email' ? 'email address' : 'phone number';

  if (!isCompleted) {
    return null;
  }

  return (
    <>
      {isSuccess ? (
        <Box flx="col" ai="center">
          <Icon icon="checkCircleFilled" size="logo" color="green" width="105px" height="105px" />
          <Title className={styles.title} title={t('title')} size="lg" bold />
          <div className={styles.message}>{t('message', { verificationType: type })}</div>
        </Box>
      ) : (
        <Box flx="col" ai="center">
          <Icon icon="blockRed" size="logo" width="105px" height="105px" color="none" />
          <Title className={styles.title} title={t('errorTitle')} size="lg" bold />
          <div className={styles.message}>{t('errorMessage', { verificationType: type })}</div>
        </Box>
      )}
    </>
  );
};

export default VerifyContact;
